import { render, staticRenderFns } from "./ZawatrialSuspended.vue?vue&type=template&id=60793858&scoped=true"
import script from "./ZawatrialSuspended.vue?vue&type=script&lang=ts"
export * from "./ZawatrialSuspended.vue?vue&type=script&lang=ts"
import style0 from "./ZawatrialSuspended.vue?vue&type=style&index=0&id=60793858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60793858",
  null
  
)

export default component.exports